import React from 'react'
import { Button, useWalletModal } from '@pancakeswap/uikit'
import useAuth from 'hooks/useAuth'
import { useTranslation } from 'contexts/Localization'

const ConnectWalletButton = (props) => {
  const { t } = useTranslation()
  const { login, logout } = useAuth()
  const { onPresentConnectModal } = useWalletModal(login, logout, t)

  return (
    <Button onClick={onPresentConnectModal} {...props} style={{ boxShadow: 'none' }}>
      {/* <img src="/images/wallet.svg" width={22} alt="wallet" />&nbsp;  */}
      {t('Connect Wallet')}
    </Button>
  )
}

export default ConnectWalletButton
